import script from "./Credential.vue?vue&type=script&setup=true&lang=js"
export * from "./Credential.vue?vue&type=script&setup=true&lang=js"

export default script